/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_3_Your_4Inputs */



/**
* | output |
* | --- |
* | "Determination of suitability for your specific use case" |
*
* @param {Guardrails_Section_3_Your_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_3_your_4 = /** @type {((inputs?: Guardrails_Section_3_Your_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_3_Your_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Entscheidung über die Angemessenheit für Ihren spezifischen Anwendungsfall")
	return /** @type {LocalizedString} */ ("Determination of suitability for your specific use case")
});